import type { OptimizelyFeature } from '@optimizely/optimizely-sdk/dist/shared_types';
import { useMemo } from 'react';
import { TableCell, TableRow } from '@mui/material';
import { Button } from '@customink/pigment-react';
import { Variations } from '~/pages/Flags/Variations';
import { CurrentVariation } from '~/pages/Flags/CurrentVariation';
import { useOptimizely } from '~/contexts/OptimizelyContext';

interface FeatureProps {
    feature: OptimizelyFeature;
}

export function FeatureRow({ feature }: FeatureProps) {
    const { resetFeatureFlag } = useOptimizely();
    const variations = useMemo(() => {
        return {
            ...feature.experimentRules[0]?.variationsMap,
            ...feature.deliveryRules[0]?.variationsMap,
        };
    }, [feature.experimentRules, feature.deliveryRules]);
    return (
        <TableRow>
            <TableCell component="th" scope="row">
                {feature.key}
            </TableCell>
            <TableCell>
                <Variations variations={variations} featureKey={feature.key} />
            </TableCell>
            <TableCell>
                <CurrentVariation feature={feature.key} />
            </TableCell>
            <TableCell>
                <Button variant="link" onClick={() => resetFeatureFlag(feature.key)} sx={{ pl: 0 }}>
                    Reset
                </Button>
            </TableCell>
        </TableRow>
    );
}
